import React from 'react';
import component from './component';
import {CursorInput} from './Form';

export default component('Search', ({data}) =>
  <div className='Search'>
    <CursorInput value={data} type='search' />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Search.js